namespace SP {
    const dictionary: { [key: string]: string } = {};

    export function addLocalization(key: string, word: string) {
        dictionary[key] = word;
    }

    export function Localize(key: string) {
        if (dictionary[key] == null) {
            console.log("JSTranslation for '" + key + "' is missing!");
            dictionary[key] = key;
        }
        return dictionary[key];
    }
}